module.exports = __webpack_public_path__ + "img/retrofited.0745526d.png";